//var RequestAnimationFrameHelper = {
//    now: new Date(),
//    duration: 0,
//    callbacks: [],
//    update: function () {
//        var now = new Date();
//        RequestAnimationFrameHelper.duration = now - RequestAnimationFrameHelper.now;
//        RequestAnimationFrameHelper.now = now;
//        for (var i = 0; i < RequestAnimationFrameHelper.callbacks.length; i++) {
//            RequestAnimationFrameHelper.callbacks[i]();
//        }
//        window.requestAnimationFrame(function () {
//            RequestAnimationFrameHelper.update();
//        });
//    },
//    onAnimationFrame: function (callback) {
//        if (callback != undefined && callback != null && typeof (callback) == "function") {
//            RequestAnimationFrameHelper.callbacks.push(callback);
//        }
//    }
//}
//window.requestAnimationFrame(function () {
//    RequestAnimationFrameHelper.update();
//});
function LanternAnimation() {
    var animationArgs = $.extend({}, arguments[0]);
    var _animation = this;
    this.$container = null;
    this.containerWidth = 0;
    this.containerHeight = 0;

    this.$dataContainer = null;
    this.dataContainerHeight = 0;

    this.dataMinLeft = 0;
    this.dataMaxLeft = 0;

    this.calculateDataContainerHeight = function () {
        _animation.dataContainerHeight = _animation.$dataContainer.outerHeight(true);
    }
    this.calculateDataMinLeft = function () {
        if (evoke.core.windowWidth() >= 1000) {
            _animation.dataMinLeft = _animation.$dataContainer.position().left;
        } else {
            _animation.dataMinLeft = 10;
        }
        return _animation.dataMinLeft;
    }
    this.calculateDataMaxLeft = function () {
        var winWidth = evoke.core.windowWidth();
        if (winWidth >= 1000) {
            _animation.dataMaxLeft = _animation.$dataContainer.position().left + _animation.$dataContainer.outerWidth(true) - 115;
        } else if (winWidth >= 768) {
            _animation.dataMaxLeft = _animation.$dataContainer.width() - 108;
        } else {
            _animation.dataMaxLeft = _animation.$dataContainer.width() - 91;
        }
        return _animation.dataMaxLeft;
    }

    function Lantern(args) {
        var _lantern = this;

        this.settings = $.extend({
            zIndex: 0,
            type: '',
            rotate: '',
            cssClass: '',
            extraClass: 'anon',
            left: 0,
            top: 0,
            maxLanternHeight: 0
        }, args);

        var left = _lantern.settings.left;
        var top = _lantern.settings.top;
        var duration = 0;
        var deltaY = 0;
        this.timeoutID = 0;


        this.getPixelsPerSecond = function () {
            switch (args.zIndex) {
                case 0:
                    return 18;
                case 1:
                    return 36;
                case 2:
                default:
                    return 54;
            }
        }
        this.getDuration = function () {
            return Math.round(parseInt(_lantern.$lantern.css('top'), 10) / _lantern.getPixelsPerSecond() * 1000);
        }

        this.render = function () {
            _lantern.$lantern.css({
                left: _lantern.settings.left,
                top: _lantern.settings.top
            });
            _animation.$container.append(_lantern.$lantern);
            this.onRenderComplete();
        }

        this.onRenderComplete = function () { }
        this.onAnimate = function () { }
        this.onAnimateComplete = function () { }

        this.animate = function () {
            /*var duration = _lantern.getDuration();
            RequestAnimationFrameHelper.onAnimationFrame(function () {
                _lantern.$lantern.css({
                    "top": "-=" + 1
                });
            });
            */
            _lantern.$lantern.animate({
                top: -(_lantern.$lantern.height())
            }, {
                duration: _lantern.getDuration(),
                easing: 'linear',
                complete: function () {
                    //respawn at the bottom
                    var position = _lantern.randomize();

                    var top = _animation.containerHeight;
                    var $prev = _lantern.$lantern.prev('.z' + _lantern.settings.zIndex.toString());
                    if ($prev.length == 0) {
                        $prev = $('.lantern.z' + _lantern.settings.zIndex.toString() + ':last');
                    }
                    top = parseInt($prev.css('top')) + _lantern.settings.maxLanternHeight;
                    if (top < _animation.containerHeight) {
                        top = _animation.containerHeight;
                    }
                    _lantern.$lantern.css('top', top);

                    _lantern.onAnimateComplete();

                    _lantern.animate();
                }
            });
            _lantern.onAnimate();

        }

        this.randomize = function () {
            _lantern.$lantern.removeClass(function (index, className) {
                var names = className.split(' ');
                var remove = [];
                for (var i = 0; i < names.length; i++) {
                    if (/^(lantern|z\d)/.test(names[i]) === false) {
                        remove.push(names[i]);
                    }
                }
                return remove.join(' ');
            });
            var newType = evoke.core.getRandomInt(1, 7);
            var newRotate = evoke.core.getRandomInt(0, 3);
            var position = _animation.RandomPosition.get(_lantern.settings.zIndex.toString());
            _lantern.$lantern.addClass('type' + newType.toString()).addClass('r' + newRotate.toString()).addClass(position.cssClass);
            _lantern.$lantern.css('left', position.left);
            return position;
        }

        this.start = function () {
            _lantern.animate();
        }

        this.stop = function () {
            _lantern.$lantern.stop();
        }



        this.$lantern = $('<div class="lantern z' + _lantern.settings.zIndex.toString() + '"></div>');

        if (typeof (_lantern.settings.cssClass) == 'string') {
            this.$lantern.addClass(_lantern.settings.cssClass);
        }
        this.$lantern.get(0).Lantern = this;
    }

    function CureLantern(args) {
        Lantern.call(this, args);
        var _cure = this;

        function getCureDuration() {
            var winWidth = evoke.core.windowWidth();
            if (winWidth >= 1000) {
                return _cure.getDuration()
            } else {
                return _cure.getDuration() * ((_animation.containerHeight - _animation.dataContainerHeight + (_cure.settings.maxLanternHeight * 1.5)) / _animation.containerHeight);
            }
        }

        function getCureHTML(data) {
            var whenCured = null;
            var cureDate = new Date(data.date);
            var years = CureLantern.now.getFullYear() - cureDate.getFullYear();
            var cureType = data.feature ? data.feature : 'anon';
            var trackName = "Patient Initials";
            if (cureType != 'anon' && data != undefined && typeof (data.name) == "string") {
                trackName = (data.name.substring(0, data.name.indexOf(" ")) + "'s");
            }
            if (years == 0) {
                var months = CureLantern.now.getMonth() - cureDate.getMonth();
                curedWhen = (months.toString() + ' month' + (months != 1 ? 's' : ''));
            } else {
                var months = CureLantern.now.getMonth() + 12 - cureDate.getMonth();
                if (months > 12) {
                    months -= 12;
                    years += 1;
                }
                whenCured = (years.toString() + ' year' + (years != 1 ? 's' : '') + (months > 0 ? ' and ' + months.toString() + ' month' + (months != 1 ? 's' : '') : ''))
            }

            if (animationArgs.dataContainer == '.lanternbox') {
                var buttonVerb = "See";
                if (typeof (data.type) == "string") {
                    switch (data.type.toLowerCase()) {
                        case "article":
                            buttonVerb = "Read";
                            break;
                    }
                }
                return ('<a class="data" href="#" data-cure-date="' + cureDate + '" data-overlaytype="' + cureType + '" data-analytics-event="[\'Real Patient Stories Lanterns\',\'Lantern Click\',\'' + data.name + '\\\'s Story\']" data-evo-gtm="Lanterns|Clicked|' + trackName + ' Lantern Card|Real Patient Stories"><div class="tbl ' + cureType + '"><div class="td"><div class="cureWhen"><strong>I LET GO</strong> of Hep&nbsp;C<br><span class="date">' + whenCured + '&nbsp;ago</span></div><div class="who">' + data.name + ', ' + CureLantern.states[data.state] + '</div><div class="storyButton">' + buttonVerb + ' my story</div></div></div></a>');

            } else {

                return ('<a class="data" href="#" data-analytics-event="[\'Real Patient Stories Lanterns\',\'Lantern Click\',\'' + data.name + '\\\'s Story\']"><strong>I LET GO</strong> of Hep&nbsp;C<br>' + whenCured + ' ago<hr>' + data.name + ', ' + CureLantern.states[data.state] + '</a>');

            }

        }

        var $cure = $('<div class="cure"></div>');
        $cure.html(getCureHTML(args.data));
        _cure.$lantern.append($cure);
        evoke.gtm.bind($cure.find("[data-evo-gtm]"));

        this.onAnimate = function () {
            /*
            var duration = _cure.getDuration();// - fadeInDelay;
            if (duration > 2000) {
      
                _cure.$lantern.animate({'opacity':1}, 1000, function () {
                    setTimeout(function () {
                        _cure.$lantern.animate({'opacity':0}, 1000);
                    }, duration - 2000);
                });
            } else {
                setTimeout(function () {
                    _cure.$lantern.animate({'opacity':0}, 1000);
                }, duration - 1000);
            }
            */
        }

        this.onAnimateComplete = function () {
            _cure.$lantern.stop();
            _cure.$lantern.css('opacity', 0);
            $cure.html(getCureHTML(LanternAnimation.data.next(animationArgs.container)));
            evoke.gtm.rebind($cure.find("[data-evo-gtm]"));
            _animation.RandomPosition.checkCureLanternPosition(_cure.$lantern);
        }

        var opacity = 1;

        function fadeInOut() {
            window.requestAnimationFrame(function () {
                var top = parseFloat(_cure.$lantern.css('top'));
                var height = parseFloat(_cure.$lantern.height());
                if (top <= 0) { //fade out
                    _cure.$lantern.css('opacity', (height + top) / height);
                } else if (top >= _animation.containerHeight - height - 30) { //fade in
                    _cure.$lantern.css('opacity', ((_animation.containerHeight - top + height) / height) - 1);
                } else {
                    _cure.$lantern.css('opacity', 1);
                }
                fadeInOut();
            });
        }

        this.onRenderComplete = function () {
            _cure.$lantern.css('opacity', 0);
            fadeInOut();
        }

        _animation.$dataContainer = _animation.$container.find(animationArgs.dataContainer);
        _animation.calculateDataContainerHeight();
        _animation.calculateDataMinLeft();
        _animation.calculateDataMaxLeft();
        _animation.RandomPosition.setRange(2, _animation.dataMinLeft, _animation.dataMaxLeft);
        $(window).on('resize', function () {
            _animation.calculateDataContainerHeight();
            _animation.calculateDataMinLeft();
            _animation.calculateDataMaxLeft();
            _animation.RandomPosition.setRange(2, _animation.dataMinLeft, _animation.dataMaxLeft);
        });
    }

    CureLantern.now = new Date();

    CureLantern.states = {
        'AL': 'Alabama',
        'AK': 'Alaska',
        'AZ': 'Arizona',
        'AR': 'Arkansas',
        'CA': 'California',
        'CO': 'Colorado',
        'CT': 'Connecticut',
        'DE': 'Delaware',
        'DC': 'Dist of Columbia',
        'FL': 'Florida',
        'GA': 'Georgia',
        'GU': 'Guam',
        'HI': 'Hawaii',
        'ID': 'Idaho',
        'IL': 'Illinois',
        'IN': 'Indiana',
        'IA': 'Iowa',
        'KS': 'Kansas',
        'KY': 'Kentucky',
        'LA': 'Louisiana',
        'ME': 'Maine',
        'MD': 'Maryland',
        'MA': 'Massachusetts',
        'MI': 'Michigan',
        'MN': 'Minnesota',
        'MS': 'Mississippi',
        'MO': 'Missouri',
        'MT': 'Montana',
        'NE': 'Nebraska',
        'NV': 'Nevada',
        'NH': 'New Hampshire',
        'NJ': 'New Jersey',
        'NM': 'New Mexico',
        'NY': 'New York',
        'NC': 'North Carolina',
        'ND': 'North Dakota',
        'OH': 'Ohio',
        'OK': 'Oklahoma',
        'OR': 'Oregon',
        'PA': 'Pennsylvania',
        'PR': 'Puerto Rico',
        'RI': 'Rhode Island',
        'SC': 'South Carolina',
        'SD': 'South Dakota',
        'TN': 'Tennessee',
        'TX': 'Texas',
        'UT': 'Utah',
        'VT': 'Vermont',
        'VI': 'Virgin Islands',
        'VA': 'Virginia',
        'WA': 'Washington',
        'WV': 'West Virginia',
        'WI': 'Wisconsin',
        'WY': 'Wyoming'
    };

    this.RandomPosition = (function () {
        var lefts = [-1, -1, -1];
        var tops = [-1, -1, -1];
        var ranges = [
          [0, 0],
          [0, 0],
          [0, 0]
        ];

        function getLeft(zIndex) {

            var min = ranges[zIndex][0]; //getRangeMin(zIndex);
            var max = ranges[zIndex][1]; //getRangeMax(zIndex);



            if (max == 0) {
                max = _animation.containerWidth;
                ranges[zIndex][1] = max;
            }

            var left = evoke.core.getRandomInt(min, max);

            var lastLeft = lefts[zIndex];



            if (lastLeft > 0) {
                if (left < lastLeft) {
                    if (left + Math.floor((max - min) * 0.2) >= lastLeft) {
                        left = lastLeft - Math.floor((max - min) * 0.2);
                        if (left < min) {
                            left = min;
                        }
                    }
                } else if (left > lastLeft) {
                    if (left - Math.floor((max - min) * 0.2) <= lastLeft) {
                        left = lastLeft + Math.floor((max - min) * 0.2);
                        if (left > max) {
                            left = max;
                        }
                    }
                } else {
                    left = _animation.RandomPosition.get(zIndex).left;
                }
            }

            if (evoke.core.windowWidth() > 1000) {
                var rtCol = evoke.$('.right-col');
                var rtColPos = rtCol.position();
                var rtColStart = Math.floor(rtColPos.left);
                var rtColEnd = Math.floor(rtColPos.left + rtCol.width());

                if (left > rtColStart - 50 && left < rtColEnd) {
                    left = left + rtCol.width() + 50;
                }
            }

            lefts[zIndex] = left;

            return left;
        }

        function get(zIndex) {
            var left = getLeft(zIndex);
            var cssClass = '';
            var min = ranges[zIndex][0]; //getRangeMin(zIndex);
            var max = ranges[zIndex][1]; //getRangeMax(zIndex);
            if (left > min + ((max - min) / 2)) {
                cssClass = 'right';
            } else {
                cssClass = 'left'
            }

            return {
                left: left,
                cssClass: cssClass
            };
        }


        function checkCureLanternPosition($lantern) {
            var left = null;
            var $cure = $lantern.find(".cure")
            if ($lantern.hasClass("left")) {
                if ($lantern.position().left + $cure.position().left + $cure.outerWidth() > $lantern.parent().width()) {
                    left = $lantern.parent().width() - $cure.position().left + $cure.outerWidth();
                }
            } else {
                if ($lantern.position().left - $cure.outerWidth() < 0) {
                    left = $cure.outerWidth();
                }
            }
            if (left != null) {
                $lantern.css("left", left.toString() + "px");
                lefts[2] = left;
            }
        }

        return {
            get: get,
            setRange: function (zIndex, min, max) {
                ranges[zIndex] = [min, max];
            },
            checkCureLanternPosition: checkCureLanternPosition
        }
    })();

    this.start = function () {
        _animation.$container.find('.lantern').each(function () {
            this.Lantern.start();
        });
    }
    this.stop = function () {
        _animation.$container.find('.lantern').each(function () {
            this.Lantern.stop();
        });
    }


    function createLanterns() {
        var isCure = false;
        var lantern = null;
        var position = null;
        for (var i = 0; i < animationArgs.layers.length; i++) {
            isCure = (animationArgs.layers[i].isCure === true);

            //if (typeof (animationArgs.layers[i].count) == 'undefined' || typeof (animationArgs.layers[i].count) != 'number') {
            if (isCure) {
                if (evoke.core.windowWidth() >= 1000) {
                    animationArgs.layers[i].count = Math.floor(_animation.containerHeight / animationArgs.maxLanternHeight);
                } else {
                    animationArgs.layers[i].count = Math.floor((_animation.containerHeight - _animation.dataContainerHeight) / animationArgs.maxLanternHeight);
                }
                animationArgs.layers[i].vspace = (_animation.containerHeight - (animationArgs.layers[i].count * animationArgs.maxLanternHeight)) / animationArgs.layers[i].count;
            } else {
                animationArgs.layers[i].count = Math.floor(_animation.containerHeight / animationArgs.maxLanternHeight / animationArgs.layers[i].ratio);
            }
            //}

            for (var j = 0; j < animationArgs.layers[i].count; j++) {
                //position = _animation.RandomPosition.get(i);
                if (isCure) {
                    lantern = new CureLantern({
                        //rotate: evoke.core.getRandomInt(0, 3),
                        zIndex: 2,
                        //type: evoke.core.getRandomInt(1, 7),
                        //left: position.left,
                        top: ((animationArgs.maxLanternHeight + animationArgs.layers[i].vspace) * j),
                        data: LanternAnimation.data.next(animationArgs.container),
                        ratio: 1,
                        //cssClass: position.cssClass,
                        maxLanternHeight: animationArgs.maxLanternHeight,
                        isCure: true
                    });
                } else {
                    lantern = new Lantern({
                        //rotate: evoke.core.getRandomInt(0, 3),
                        zIndex: i,
                        //type: evoke.core.getRandomInt(1, 7),
                        //left: position.left,
                        top: Math.ceil(animationArgs.maxLanternHeight * animationArgs.layers[i].ratio * j),
                        ratio: animationArgs.layers[i].ratio,
                        maxLanternHeight: Math.ceil(animationArgs.maxLanternHeight * animationArgs.layers[i].ratio)
                    });
                }
                lanterns.push(lantern);
            }
        }

        var screenshot = httpUtility.queryString("screenshot") === "true"
        for (var i = 0; i < lanterns.length; i++) {
            lanterns[i].render();
            lanterns[i].randomize();
            if (lanterns[i].settings.zIndex == 2) {
                _animation.RandomPosition.checkCureLanternPosition(lanterns[i].$lantern);
            }
            if (!screenshot) {
                lanterns[i].animate();
            }
        }
    }




    _animation.$container = $(animationArgs.container);
    _animation.containerWidth = _animation.$container.width();
    _animation.containerHeight = _animation.$container.outerHeight();
    $(window).on('resize', function () {
        _animation.containerWidth = _animation.$container.width();
        _animation.containerHeight = _animation.$container.outerHeight();
    });

    var lanterns = [];

    var dataURL = '/~/media/Files/harvoni_com/json/cures.json';
    if (location.hostname.toLowerCase() == 'localhost') {
        dataURL = '/js/common/cureData.min.json'
    }

    var featuredDataURL = '/~/media/Files/harvoni_com/json/featuredcure.json';
    if (location.hostname.toLowerCase() == 'localhost') {
        featuredDataURL = '/js/common/featureCureData.min.json'
    }

    var requiresData = false;
    for (var i = 0; i < animationArgs.layers.length; i++) {
        if (animationArgs.layers[i].isCure === true) {
            requiresData = true;
            break;
        }
    }
    if (requiresData && !LanternAnimation.data.exists()) {

        evoke.core.loadJson(featuredDataURL, function (data) {
            LanternAnimation.data.set(data, 'featured');

            evoke.core.loadJson(dataURL, function (data) {
                LanternAnimation.data.set(data);
                createLanterns();
            });

        });

    } else {
        createLanterns();
    }


}
LanternAnimation.instances = [];
LanternAnimation.create = function () {
    var args = {
        container: 'section.patient-stories',
        dataContainer: '.left-col',
        maxLanternHeight: 160,
        layers: [{
            ratio: 0.33
        }, {
            ratio: 0.66
        }, {
            isCure: true,
            ratio: 1
        }]
    };
    $.extend(args, arguments[0]);
    var instance = new LanternAnimation(args);
    LanternAnimation.instances[args.container] = instance;
    return instance;
};
LanternAnimation.data = (function () {
    var index = 0;
    var data = null;
    var featuredData = null;
    var containers = [];

    function randomize(cureData) {
        var cures = cureData.slice();
        var randomized = [];
        var totalCures = cureData.length;
        var index = 0;
        while (randomized.length < totalCures) {
            index = evoke.core.getRandomInt(0, cures.length);
            randomized.push(cures[index]);
            cures.splice(index, 1);
        }
        return randomized;
    }

    //function mergeCures() {

    //  var merged = [];
    //  var totalData = data.length;
    //  var j = 0;


    //  for (var i = 0; i < totalData; i++) {

    //    if (i % 3 === 2) { // EVERY 3RD CURE SHOULD BE A FEATURED CURE

    //      if (j > featuredData.length - 1) {
    //        j = 0;
    //      }

    //      merged.push(featuredData[j]);

    //      j = j + 1;

    //    } else {
    //      merged.push(data[i]);
    //    }

    //  }

    //  return merged;
    //}

    function addCuresWithin(cures, cureDate, months, maxCures) {
        if (cures.length < maxCures) {
            if (months > 0) {
                var dateBefore = new Date(cureDate.setMonth(cureDate.getMonth() - months));
                var monthBefore = dateBefore.getMonth();
                var yearBefore = dateBefore.getFullYear();
                var dateAfter = new Date(cureDate.setMonth(cureDate.getMonth() + months));
                var monthAfter = dateAfter.getMonth();
                var yearAfter = dateAfter.getFullYear();
                var before = [];
                var after = [];
                for (var i = 0; i < data.length; i++) {
                    var date = new Date(data[i].date);
                    var year = date.getFullYear();
                    var month = date.getMonth();
                    if (year == yearAfter && month == monthAfter) {
                        after.push(data[i]);
                        if (cures.length + before.length + after.length >= maxCures) {
                            break;
                        }
                    } else if (year == yearBefore && month == monthBefore) {
                        before.push(data[i]);
                        if (cures.length + before.length + after.length >= maxCures) {
                            break;
                        }
                    }
                }
                return before.concat(cures).concat(after);
            } else {
                var exact = [];
                var cureYear = cureDate.getFullYear();
                var cureMonth = cureDate.getMonth();
                for (var i = 0; i < data.length; i++) {
                    var date = new Date(data[i].date);
                    if (date.getFullYear() == cureYear && date.getMonth() == cureMonth) {
                        exact.push(data[i]);
                        if (cures.length + exact.length >= maxCures) {
                            break;
                        }
                    }
                }
                return cures.concat(exact);
            }
        } else {
            return cures;
        }
    }

    return {
        exists: function () {
            return data != null;
        },
        set: function (cureData, y) {
            if (y === 'featured') {
                featuredData = randomize(cureData);
            } else {
                data = randomize(cureData);
                //data = mergeCures();
            }
        },
        next: function (containerID) {
            var featuredIndex = null;
            if (containerID != undefined && containerID != null) {
                if (containers[containerID] == undefined) {
                    containers[containerID] = { count: 0, featured: 0 };
                }
                if (containers[containerID].count == 2) {
                    featuredIndex = containers[containerID].featured;
                    containers[containerID].count = 0;
                    if (featuredIndex + 1 < featuredData.length) {
                        containers[containerID].featured = featuredIndex + 1;
                    } else {
                        containers[containerID].featured = 0;
                    }
                } else {
                    containers[containerID].count++;
                }
            }

            if (featuredIndex != null) {
                return featuredData[featuredIndex];
            } else {
                if (index < data.length) {
                    return data[index++];
                } else {
                    index = 0;
                    return data[0]
                }
            }
        },
        get: function (count, date) {
            if (date != undefined && date != null) {
                var cureDate = null;
                if (typeof (date) == "object" && date instanceof Date) {
                    cureDate = date;
                } else {
                    cureDate = new Date(date);
                }

                var cures = [];
                var within = 0;
                while (cures.length < count) {
                    cures = addCuresWithin(cures, cureDate, within, count);
                    within++;
                }
                return cures;
            } else if (count < data.length) {
                var cures = data.slice();
                var randomized = [];
                var index = 0;
                while (randomized.length < count) {
                    index = evoke.core.getRandomInt(0, cures.length);
                    randomized.push(cures[index]);
                    cures.splice(index, 1);
                }
                return randomized;
            } else {
                return data;
            }
        }
    }
})();